import Container from "react-bootstrap/Container";
import {json, redirect, useFetcher, useLoaderData, useOutletContext} from "react-router-dom";
import Button from "react-bootstrap/Button";
import {FormControl, FormGroup, FormLabel, Stack} from "react-bootstrap";

export const booksOpenAdminLoader = (getAuth) => async () => {
    console.log("books open admin loader")
    try {
        let auth = await getAuth();
        let artist = auth.username === "jockerse" ? "erika" : auth.username;
        let response = await fetch(`https://botanical.ink/api/admin/${artist}/settings/books-open-until`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth.idToken.getJwtToken()}`,
            },
        });
        if (response.ok) {
            console.log("ok")
            return await response.json();
        } else {
            return json({
                error: response.status
            })
        }
    } catch (error) {
        console.log(error)
        if (error === "NOT VALID") {
            return redirect("/login")
        } else {
            throw error
        }
    }
}

export const scheduleAdminAction = (getAuth) => async ({params, request}) => {
    console.log("create flash set action")

    let auth = await getAuth();
    let artist = auth.username;
    if (auth.username === "jockerse") {
        artist = "erika";
    }

    let formData = await request.formData();

    let intent = formData.get("intent");
    console.log(intent);
    if (intent === "books") {
        return await booksOpenAction(auth, artist, formData);
    } else if (intent === "timeoff") {
        return await timeOffAction(auth, artist, formData);
    } else {
        return {
            error: "Invalid intent"
        }
    }

}

const timeOffAction = async (auth, artist, formData) => {
    let data = {
        start: formData.get("start"),
        end: formData.get("end")
    }

    console.log("time off action", data)

    try {
        let response = await fetch(`https://botanical.ink/api/admin/${artist}/time-off/`, {
            method: "post",
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth.idToken.getJwtToken()}`,
            }
        });
        if (response.ok) {
            return await response.json();
        } else {
            return response;
        }
    } catch (error) {
        console.log(error)
        return {error: error.message}
    }
}

const booksOpenAction = async (auth, artist, formData) => {
    let data = {
        date: formData.get("date")
    }

    try {
        let response = await fetch(`https://botanical.ink/api/admin/${artist}/settings/books-open-until`, {
            method: "post",
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth.idToken.getJwtToken()}`,
            }
        });
        if (response.ok) {
            return await response.json();
        } else {
            return response;
        }
    } catch (error) {
        console.log(error)
        return {error: error.message}
    }
}

export const ScheduleAdmin = () => {
    const {darkMode} = useOutletContext();
    const loaderData = useLoaderData();
    const booksFetcher = useFetcher({key: "books-open-fetcher"});
    const timeOffFetcher = useFetcher({key: "time-off-fetcher"});

    return (
        <>
            <Container className={`${darkMode && "text-light"} d-flex flex-column rounded-3 mb-3`}>
                <h3 className={"text-center"}>Schedule and Time Off</h3>
            </Container>

            <booksFetcher.Form method={"post"}>
                <Container
                    className={`${darkMode && "text-light bg-success"} d-flex flex-column row-gap-3 rounded mb-3 p-3`}>
                    <FormGroup>
                        <FormLabel htmlFor={"date"}>Books Open Until</FormLabel>
                        <FormControl type={"date"}
                                     name={"date"}
                                     defaultValue={loaderData.date}
                        />
                    </FormGroup>
                    <Button type={"submit"} name="intent" value="books">
                        {booksFetcher.state === "idle" && "Submit Change"}
                        {booksFetcher.state === "loading" && "Loading..."}
                        {booksFetcher.state === "submitting" && "Submitting..."}
                    </Button>
                </Container>
            </booksFetcher.Form>

            <timeOffFetcher.Form method={"post"}>
                <Container
                    className={`${darkMode && "text-light bg-success"} d-flex flex-column row-gap-3 rounded mb-3 p-3`}>
                    <h4>Time Off</h4>
                    <Stack direction="horizontal" gap={3} className="d-flex flex-row justify-content-center">
                        <FormGroup className="flex-grow-1">
                            <FormLabel htmlFor={"start"}>Start</FormLabel>
                            <FormControl type={"date"}
                                         name={"start"}
                                         required
                            />
                        </FormGroup>

                        <FormGroup className="flex-grow-1">
                            <FormLabel htmlFor={"end"}>End</FormLabel>
                            <FormControl type={"date"}
                                         name={"end"}
                                         required
                            />
                        </FormGroup>
                    </Stack>
                    <Button type={"submit"} name="intent" value="timeoff">
                        {booksFetcher.state === "idle" && "Submit"}
                        {booksFetcher.state === "loading" && "Loading..."}
                        {booksFetcher.state === "submitting" && "Submitting..."}
                    </Button>

                </Container>
            </timeOffFetcher.Form>
        </>
    );
}